var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-radio-group',{attrs:{"value":_vm.value+''},on:{"input":function($event){return _vm.$emit('input', $event)}}},_vm._l((_vm.dataList),function(data){return _c('el-radio',{key:data.dictValue,attrs:{"label":data.dictValue}},[_vm._v(_vm._s(data.dictLabel))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }